// extracted by mini-css-extract-plugin
module.exports = {"tabListScroller":"Tabs_tabListScroller__NEhpV","tabList":"Tabs_tabList__h_edF","tab":"Tabs_tab__cN0lF"};